export interface TaskStatusInfo {
  label: string;
  appearance: string;
}

const FALLBACK_STATUS: TaskStatusInfo = {
  label: 'Неизвестно',
  appearance: 'neutral'
};

export const TASK_STATUS_INFO: Record<number, TaskStatusInfo> = {
  1: { label: 'Запланирован', appearance: 'info' },
  2: { label: 'Завершён', appearance: 'success' },
  3: { label: 'Перенесён', appearance: 'warning' },
  4: { label: 'Отменён', appearance: 'error' },
  5: { label: 'Удалён', appearance: 'neutral' }
};

export function taskStatusInfo(statusId: number): TaskStatusInfo {
  return TASK_STATUS_INFO[statusId] ?? FALLBACK_STATUS;
}

export interface HeatmapCellVisit {
  taskId: number;
  organizationName: string;
  score: number;
}

export interface HeatmapCell {
  employeeId: number;
  employeeName: string;
  day: string;
  score: number | null;
  visits: HeatmapCellVisit[];
}
